export default {
  add: 'Add',
  addProperty: 'Add property',
  addTags: 'Add tags',
  emptyCollection: 'No items added yet',
  emptyTags: 'No tags added yet',
  dropToAdd: 'Drop to add',
  addingItem: 'Adding item…',
  cannotAddDraggedItem: 'Can’t add this item',
  addPhotos: 'Add photos',
  addFiles: 'Add files',
  photosFromDevice: 'Images from your device',
  filesFromDevice: 'Documents and other files',
  selectedModel: 'This model',
  imagesUnsupported: "{{model}} doesn't support images",
  cancel: 'Cancel',
  close: 'Close',
  delete: 'Delete',
  rename: 'Rename',
  more: 'More',
  search: 'Search',
  selectItem: 'Select item',
  settings: 'Settings',
};
